var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('Header'),_c('section',{staticClass:"hbox stretch"},[_c('Sidebar'),_c('section',{staticClass:"content"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }